import { render, staticRenderFns } from "./ProductLabelList.vue?vue&type=template&id=94af8444"
import script from "./ProductLabelList.vue?vue&type=script&lang=js"
export * from "./ProductLabelList.vue?vue&type=script&lang=js"
import style0 from "./ProductLabelList.vue?vue&type=style&index=0&id=94af8444&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports